export default "__VITE_ASSET__C5aYpG6u__"